import { render, staticRenderFns } from "./smart-electrification-&-automation.vue?vue&type=template&id=2ef0688f&"
import script from "./smart-electrification-&-automation.vue?vue&type=script&lang=js&"
export * from "./smart-electrification-&-automation.vue?vue&type=script&lang=js&"
import style0 from "./smart-electrification-&-automation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports